import { render, staticRenderFns } from "./gateway-downtimes.vue?vue&type=template&id=2d89f31e&"
import script from "./gateway-downtimes.vue?vue&type=script&lang=js&"
export * from "./gateway-downtimes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports